import { useEffect, useRef, useState } from "react";
import { MessageCircle, Send, Users } from "lucide-react";

export const PartyChat = ({ messages, viewers, nick, clientId, onSend, disabled }) => {
  const [text, setText] = useState("");
  const listRef = useRef(null);

  useEffect(() => {
    const el = listRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [messages.length]);

  const submit = (e) => {
    e.preventDefault();
    const t = text.trim();
    if (!t) return;
    onSend(t);
    setText("");
  };

  return (
    <div className="glass rounded-xl flex flex-col h-[520px] lg:h-[calc(100vh-180px)] lg:max-h-[720px]" data-testid="party-chat">
      <div className="flex items-center gap-2 p-4 border-b border-[color:var(--border)]">
        <MessageCircle className="w-4 h-4 text-[color:var(--accent)]" />
        <h2 className="font-display text-xl">Chat en direct</h2>
        <span className="ml-auto inline-flex items-center gap-1.5 text-xs text-[color:var(--text-muted)]" data-testid="party-viewers">
          <span className="live-dot" /><Users className="w-3.5 h-3.5" /> {viewers} en ligne
        </span>
      </div>
      <ol ref={listRef} className="flex-1 overflow-y-auto p-3 space-y-2" data-testid="party-messages">
        {messages.map(m => {
          const mine = m.client_id && m.client_id === clientId;
          if (m.system) {
            return <li key={m.id} className="text-center text-[10px] uppercase tracking-widest text-[color:var(--accent)]/80 py-1" data-testid="party-msg-system">{m.text}</li>;
          }
          return (
            <li key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`} data-testid="party-msg">
              <div className={`max-w-[85%] rounded-2xl px-3 py-2 text-sm ${mine ? "bg-[color:var(--accent)] text-black rounded-br-sm" : "bg-[color:var(--bg-elev-2)] rounded-bl-sm"}`}>
                {!mine && <div className="text-[10px] uppercase tracking-widest text-[color:var(--accent)] mb-0.5">{m.nick}</div>}
                <div className="break-words">{m.text}</div>
                <div className={`text-[9px] mt-0.5 ${mine ? "text-black/60" : "text-[color:var(--text-muted)]"}`}>{new Date(m.ts).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}</div>
              </div>
            </li>
          );
        })}
        {messages.length === 0 && <li className="text-center text-xs text-[color:var(--text-muted)] py-8">Soyez le premier à écrire…</li>}
      </ol>
      <form onSubmit={submit} className="p-3 border-t border-[color:var(--border)] flex gap-2">
        <input
          data-testid="party-chat-input"
          value={text}
          onChange={e => setText(e.target.value)}
          maxLength={280}
          disabled={disabled}
          placeholder={disabled ? "Choisissez un pseudo pour parler" : `Parler en tant que ${nick}…`}
          className="flex-1 bg-[color:var(--bg-elev)] border border-[color:var(--border)] rounded-full px-4 py-2 text-sm focus:outline-none focus:border-[color:var(--accent)] transition-colors disabled:opacity-50"
        />
        <button data-testid="party-chat-send" disabled={disabled || !text.trim()} aria-label="Envoyer" className="w-10 h-10 rounded-full bg-[color:var(--accent)] text-black grid place-items-center disabled:opacity-40 hover:brightness-110 transition">
          <Send className="w-4 h-4" />
        </button>
      </form>
    </div>
  );
};
